import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {Observable, Subscriber} from 'rxjs';
import {FormGroup} from '@angular/forms';
import {IDropdownData, IDropdownMeta} from '../pages/shared/types/general.types';

@Injectable()
export class DropdownService {

    DROPDOWN_NOT_FOUND = {
        name_ps: '--پیدا نشو--',
        name_prs: '--یافت نشد--',
        name_en: '--Not found--',
        slug: '--not-found--'
    };

    constructor(private httpService: HttpService) {
    }

    validateAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.httpService.get(`api/dropdown/last-update-ts`).subscribe((serverMeta: IDropdownMeta[]) => {
                for (const meta of serverMeta) {
                    let foundItem: IDropdownMeta;
                    try {
                        foundItem = JSON.parse(localStorage.getItem(
                            `dropdown-meta~${meta.source}|||${meta.type_slug}`
                        ));
                        if (!foundItem) {
                            throw new Error('[Dropdown Service]: Item not found, handle it in catch');
                        }
                    } catch (e) {
                        meta.isUpToDate = false;
                        localStorage.setItem(
                            `dropdown-meta~${meta.source}|||${meta.type_slug}`,
                            JSON.stringify(meta));
                        continue;
                    }
                    meta.isUpToDate = meta.last_update_ts === foundItem.last_update_ts;
                    localStorage.setItem(
                        `dropdown-meta~${meta.source}|||${meta.type_slug}`,
                        JSON.stringify(meta));
                }
                resolve();
            }, (error) => {
                console.error(error);
                // TODO: do it properly
                reject();
            });
        }) as Promise<any>;
    }

    getData(source: string, typeSlug: string): Observable<IDropdownData[]> {
        return new Observable((observer: Subscriber<any>) => {
            // Get the meta for dropdown
            let foundMeta: IDropdownMeta;
            try {
                foundMeta = JSON.parse(localStorage.getItem(`dropdown-meta~${source}|||${typeSlug}`));
                if (!foundMeta) {
                    throw new Error(`[Dropdown Service]: Error getting requested dropdown item data. \r\nsource -> ${source}\r\ntypeSlug -> ${typeSlug}`);
                }
            } catch (e) {
                console.error(e.message);
                throw Error(e.message);
            }

            // If dropdown is up to date, return the its data
            if (foundMeta.isUpToDate) {
                try {

                    const data: IDropdownData = JSON.parse(localStorage.getItem(`dropdown-data~${source}|||${typeSlug}`));
                    if (data) {
                        observer.next(data);
                        observer.complete();
                        return;
                    }
                } catch (error) {
                    console.error(error);
                    throw Error('Error in data sync');

                }
            }

            // If dropdown is NOT up to date or its data is not found, fetch it from the server
            this.httpService.get(`api/dropdown/${source}/${typeSlug}`).subscribe((data: IDropdownData[]) => {
                localStorage.setItem(`dropdown-data~${source}|||${typeSlug}`, JSON.stringify(data));
                foundMeta.isUpToDate = true;
                localStorage.setItem(`dropdown-meta~${source}|||${typeSlug}`, JSON.stringify(foundMeta));

                observer.next(data);
                observer.complete();
            }, (error) => {
                console.error(error);
                throw Error('Error in data fetch');
            });
        });
    }

    getItem(source: string, typeSlug: string, slug: string): IDropdownData {
        const foundDropdown: IDropdownData[] = JSON.parse(localStorage.getItem(`dropdown-data~${source}|||${typeSlug}`));
        if (!foundDropdown) {
            return this.DROPDOWN_NOT_FOUND;
        }
        const foundItem: IDropdownData = foundDropdown.find((item: IDropdownData) => {
            return item.slug === slug;
        });

        if (!foundItem) {
            return this.DROPDOWN_NOT_FOUND;
        }
        return foundItem;
    }

    generateSlug(nameEn?: string, id?: number, currentValue?: string): string {
        if (id) {
            return currentValue;
        }

        if (!nameEn) {
            return '';
        }

        const replaceableCharacters = [
            ' ', '_', ',', '/', '\\'
        ];
        let slugBuilt = '';

        nameEn = nameEn.trim().toLowerCase();


        for (let i = 0; i < nameEn.length; i++) {
            if (/^[a-zA-Z0-9\-]$/.test(nameEn[i])) {
                slugBuilt += nameEn[i];
                continue;
            }
            const matched = replaceableCharacters.find((current: string) => {
                return current === nameEn[i];
            });
            if (matched) {
                slugBuilt += '-';
            }
        }
        return slugBuilt;
    }

    setSlug(form: FormGroup, slugSource: string, slug: string, id: number): void {
        form.get(slug).setValue(this.generateSlug(slugSource, id, form.get(slug).value));
    }
}
